<template>
  <select class="custom-select"
          :disabled="loading"
          @change="filterByClassification"
          ref="classifications">
    <option selected value="">Filtrar por</option>
    <option value="">Mostrar todas</option>
    <option v-for="classification in classifications"
            :value="classification.id"
            :key="classification.id">{{ classification.title }}
    </option>
  </select>
</template>

<script>
  import { mapActions } from 'vuex'
  
  export default {
    name: 'TaskClassifications',
    data() {
      return {
        classifications: [],
        loading: false,
      }
    },
    methods: {
      ...mapActions({
        getClassifications: 'tasks/getClassifications',
      }),
      
      filterByClassification(e) {
        this.$emit('classification-selected', this.$refs.classifications.value)
      }
    },
    async mounted () {
      this.loading = true
      
      this.classifications = (await this.getClassifications()).classifications
  
      this.loading = false
    },
  }
</script>
